import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  ClipboardList,
  Truck,
  User,
  FileText,
  Upload,
  UserCircle,
} from "lucide-react";
import "./sidebar.css";

const Sidebar = ({ isCollapsed, toggleCollapse }) => {
  const location = useLocation();

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: LayoutDashboard },
    { name: "Trips", path: "/trips", icon: ClipboardList },
    { name: "Trucks", path: "/trucks", icon: Truck },
    { name: "Drivers", path: "/drivers", icon: User },
    { name: "Bilties", path: "/bilties", icon: FileText },
    { name: "Export", path: "/export", icon: Upload },
    { name: "Profile", path: "/profile", icon: UserCircle },
  ];

  return (
    <aside 
    className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        {!isCollapsed && <span className="logo-text">TruckBase</span>}
        <button className="collapse-btn" onClick={toggleCollapse}>
          ☰
        </button>
      </div>

      <ul className="sidebar-menu">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <li
              key={item.path}
              className={location.pathname === item.path ? "active" : ""}
            >
              <Link to={item.path}>
                <Icon size={20} />
                {!isCollapsed && <span>{item.name}</span>}
              </Link>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default Sidebar;
